import { ref } from "@vue/reactivity";
import { onMounted, onUpdated } from "@vue/runtime-core";

export default () => {
    const companyProfile = ref(null);
    const authForm = ref(null);
    const minHeight = ref(null);

    onMounted(() => {
        // console.log(companyProfile.value.offsetHeight)
        minHeight.value =
            companyProfile.value.offsetHeight > authForm.value.offsetHeight
                ? companyProfile.value.offsetHeight + 100
                : authForm.value.offsetHeight + 100;
    });

    onUpdated(() => {
        minHeight.value =
            companyProfile.value.offsetHeight > authForm.value.offsetHeight
                ? companyProfile.value.offsetHeight + 100
                : authForm.value.offsetHeight + 100;
    });

    return {minHeight, companyProfile, authForm}
}